module.exports = __webpack_public_path__ + "static/hero-projects-marketspace-dd2d29c9f29e0211cb7499f7dfa563ac.svg";